<template>
    <div :class="wrapperClass">
        <label class="label-caption">
            {{ item.nmcaption }}
            <span v-if="isObrigatorio" class="required">*</span>
        </label>

        <DocDynamicInput
            :tpfield="tpField"
            :maxlength="item.textlength"
            :model-value="modelValue"
            @update:model-value="onInput"
        />

        <textarea
            v-if="item.ckinformacoes === 'S'"
            class="doc-info"
            placeholder="Informações complementares"
            :value="item.informacoes || ''"
            @input="onInputInformacoes"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import DocDynamicInput from './DocDynamicInput.vue';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['update:item']);

const textLength = computed(() => props.item.textlength || 200);
const tpField = computed(() => props.item.tpfield || 'TEXTO');

const isObrigatorio = computed(() => props.item.ckobrigatorio === 'S');

const wrapperClass = computed(() => {
    if (tpField.value === 'CPF') return 'form-item-char15';
    if (tpField.value === 'CNPJ') return 'form-item-char20';
    if (tpField.value === 'CEP') return 'form-item-char15';
    if (['FONE', 'TELEFONE'].includes(tpField.value)) return 'form-item-telefone';
    if (tpField.value === 'DATA') return 'form-item-data';
    if (tpField.value === 'HORA') return 'form-item-char10';
    if (tpField.value === 'NUMERO') return 'form-item-char15';
    // regras de tamanho
    if (textLength.value <= 20) return 'form-item-char20';
    if (textLength.value <= 50) return 'form-item-char50';
    return 'form-item';
})


const modelValue = computed(() => {
    switch (tpField.value) {
        case 'DATA':
            return props.item.resposta_data || '';

        case 'NUMERO':
            return props.item.resposta_numero ?? '';

        default:
            return props.item.resposta_texto || '';
    }
});

function onInput(value) {
    const itemAtualizado = { ...props.item };

    switch (tpField.value) {
        case 'DATA':
            itemAtualizado.resposta_data = value || null;
            break;

        case 'NUMERO':
            itemAtualizado.resposta_numero = value === '' ? null : Number(value);
            break;

        default:
            itemAtualizado.resposta_texto = value;
            break;
    }

    emit('update:item', itemAtualizado);
}

function onInputInformacoes(event) {
    emit('update:item', {
        ...props.item,
        informacoes: event.target.value
    });
}
</script>

<style scoped>
.required {
    color: #b00020;
    margin-left: 3px;
}

.doc-info {
    margin-top: 8px;
    min-height: 70px;
    resize: vertical;
}
</style>